import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';

@Component({
  selector: 'hypecast-admin-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  standalone: true,
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  readonly templateRef = input.required<TemplateRef<unknown>>();

  readonly isLoading = input(false);

  readonly cssClass = input('');
}
